import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import { slotStore} from '@gongxigames/framework/slotV2/globals';
import {listenUIDisabled} from '@gongxigames/framework/slotV2/ui/acts/utils';

export class RespinIdleUIAct extends SyncUIActDecorator {
    public execute(): void {
        listenUIDisabled(this);

        this.emitter.emit('General.enableSpinButton');

        this.emitter.on('UI.spinButton.pressed', this.onSpinStartedByButton.bind(this));
        this.emitter.on('UI.skipButton.pressed', this.onSkipByButton.bind(this));
    }

    protected onSpinStartedByButton(): void {
        this.emitter.emit('UI.command.spin');
        slotStore.batchUpdate({feature_type: {type: 'respins', amount: 0}});

        this.onExecuted?.();
    }

    protected onSkipByButton(): void {
        this.emitter.emit('UI.command.spin');
        this.emitter.emit('Game.command.round.uiDisabled');
    }

    getName(): string {
        return 'RespinIdleUIAct';
    }
}